import { supabase } from './supabase';

/**
 * Product waitlist on subscriber_mcp_access — not subscribers.
 * Activated is a live subscriber_mcp_activations row.
 */
export const SUBSCRIBER_ACCESS_STATUSES: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'not_applied', label: 'Not applied' },
  { value: 'waitlisted', label: 'Waitlisted' },
  { value: 'invited', label: 'Invited' },
];

export function subscriberAccessStatus(value: string | null | undefined): string {
  return typeof value === 'string' ? value.trim() : '';
}

export async function loadMcpAccessStatus(subscriberId: string): Promise<string> {
  const { data, error } = await supabase
    .from('subscriber_mcp_access')
    .select('access_status')
    .eq('subscriber_id', subscriberId)
    .maybeSingle();
  if (error || !data) return 'not_applied';
  return subscriberAccessStatus((data as { access_status?: string }).access_status) || 'not_applied';
}

export async function saveMcpAccessStatus(
  subscriberId: string,
  accessStatus: string,
): Promise<void> {
  const now = new Date().toISOString();
  const { error } = await supabase.from('subscriber_mcp_access').upsert(
    {
      subscriber_id: subscriberId,
      access_status: accessStatus,
      updated_at: now,
      ...(accessStatus === 'waitlisted' ? { waitlisted_at: now } : {}),
      ...(accessStatus === 'invited' ? { invited_at: now } : {}),
    },
    { onConflict: 'subscriber_id' },
  );
  if (error) throw error;
}
